<template>
    <span>
        <weaver-hero></weaver-hero>
        <weaver-details></weaver-details>
        <weaver-plans></weaver-plans>
         <weaver-get></weaver-get>
         <weaver-faqs></weaver-faqs>
         <div style="background:#222222;color:#86af49;text-align:center;padding-top:20px">Copyright © 2020 Splashweave Pty Ltd</div>
    </span>
</template>

<script>
import WeaverHero from '@/components/WeaverHero';
import WeaverDetails from '@/components/WeaverDetails';
import WeaverPlans from '@/components/WeaverPlans';
import WeaverGet from '@/components/WeaverGet';
import WeaverFaqs from '@/components/WeaverFaqs';

export default {
  name: "weaver",
  components: {
    WeaverHero,
    WeaverDetails,
     WeaverPlans,
     WeaverGet,
     WeaverFaqs
  }
};
</script>
